<div class="terra-notification-card" [ngClass]="{ 'terra-notification-card--read': !unread }">
  <div class="terra-notification-card__avatar">
    <ng-content select="terra-avatar" />
  </div>

  <div class="terra-notification-card__content">
    <div class="terra-notification-card__header">
      <div class="terra-notification-card__title">
        <ng-content select="terra-notification-card-title" />
      </div>
      <div class="terra-notification-card__status">
        @if (unread) {
          <terra-badge class="terra-notification-card__status--badge" size="tiny" color="warning" />
        }
      </div>
    </div>
    <div class="terra-notification-card__suffix">
      <ng-content select="terra-notification-card-suffix" />
    </div>
    <div class="terra-notification-card__description">
      <ng-content select="terra-description" />
    </div>
  </div>
</div>
